export default __webpack_public_path__ + "static/media/about.5bc08f2b.jpg";